import React, { useState } from 'react'
import {
  Button,
  ButtonType,
  Checkbox,
  TextInput,
} from '@resurs-internal/styx-react'
import SyntaxHighlighter from 'react-syntax-highlighter'
import { uuid } from '../utils/testUtils'
import { Card } from './Card'

import commonStyles from './styles.module.scss'

const prettyPrintData = dataString =>
  dataString && JSON.stringify(JSON.parse(dataString), null, 2)

export const RequestEditor = ({
  events = [],
  value: {
    data = '',
    description = '',
    path = '',
    status = '',
    method = 'GET',
    delay = 0,
    id = uuid(),
    activeEvents = events.map(({ props: { id: evId } }) => evId).join(','),
  } = {},
  onChange,
  onDelete,
  onCopy,
  isNew = false,
}) => {
  const [edit, setEdit] = useState(isNew)
  const [invalid, setInvalid] = useState(false)
  const [internalValue, setInternalValue] = useState(prettyPrintData(data))
  const [props, setProps] = useState({
    description,
    path,
    status,
    method,
    delay,
    id,
    activeEvents,
  })

  const onChangeDataInternal = next => {
    console.log(next)
    setInternalValue(next)
    try {
      onChange({
        data: prettyPrintData(next),
        description,
        path,
        status,
        method,
      })
      setInvalid(false)
    } catch (e) {
      setInvalid(true)
    }
  }

  const onChangeProp = (key, value) =>
    setProps(prev => ({ ...prev, [key]: value }))

  const save = () => {
    onChange({
      ...props,
      data: JSON.stringify(JSON.parse(internalValue)),
    })
    setEdit(false)
  }

  return (
    <Card header="Request Mock">
      <div className={commonStyles.flexCol}>
        <div className={commonStyles.flexCol}>
          {events.map(
            ({ props: { id: eventId, description: eventDescription } }) => (
              <Checkbox
                id={`${id}-event-active-${eventId}`}
                label={eventDescription}
                disabled={!edit}
                checked={props.activeEvents?.includes(eventId)}
                onChange={({ target: { checked } }) => {
                  onChangeProp(
                    'activeEvents',
                    [
                      ...props.activeEvents
                        .split(',')
                        .filter(evId => evId !== eventId),
                      checked ? eventId : null,
                    ]
                      .filter(evId => !!evId)
                      .join(','),
                  )
                }}
              />
            ),
          )}
        </div>
        <TextInput
          id="description"
          label="Description"
          value={props.description}
          disabled={!edit}
          onChange={onChangeProp}
        />
        <TextInput
          id="path"
          label="Request path"
          value={props.path}
          disabled={!edit}
          onChange={onChangeProp}
        />
        <TextInput
          id="method"
          label="Http method"
          value={props.method}
          disabled={!edit}
          onChange={onChangeProp}
        />
        <TextInput
          id="status"
          label="Http Status"
          value={props.status}
          disabled={!edit}
          onChange={onChangeProp}
        />
        <TextInput
          id="delay"
          label="Delay (ms)"
          type="number"
          value={`${props.delay}`}
          disabled={!edit}
          onChange={(key, value) => onChangeProp(key, +value)}
        />
        {edit ? (
          <textarea
            value={internalValue}
            onChange={e => onChangeDataInternal(e.target.value)}
            style={{ minHeight: '400px', fontSize: '12px' }}
            rows={(internalValue.match(/\n/g)?.length || 0) + 2}
          />
        ) : (
          <SyntaxHighlighter
            language="json"
            customStyle={{ fontSize: '13px', lineHeight: '14px' }}
          >
            {prettyPrintData(data)}
          </SyntaxHighlighter>
        )}
        <div
          style={{ flexDirection: 'row-reverse' }}
          className={commonStyles.flexRow}
        >
          <Button
            id={`edit_gizmo_${props.id}`}
            type={ButtonType.Primary}
            disabled={invalid}
            onClick={() => (edit ? save() : setEdit(!edit))}
          >
            {edit ? 'Done' : 'Edit'}
          </Button>
          <Button id={`duplicate_gizmo_${props.id}`} onClick={onCopy}>
            Duplicate
          </Button>
          <Button
            id={`delete_gizmo_${props.id}`}
            type="secondary"
            onClick={onDelete}
          >
            Delete
          </Button>
        </div>
      </div>
    </Card>
  )
}
